export default "__VITE_ASSET__B$KN_G6H__"